import {
    STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getModelsDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                yearOptions: [],
                versionOptions: [],
                modelOptions: [],
                modelOptionsError: null,
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getModelsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                modelOptions: action.data,
                modelOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getModelsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                modelOptions: [],
                modelOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  